"use strict";
/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
Object.defineProperty(exports, "__esModule", { value: true });
var styles = ["#unit-search-container[_ngcontent-%COMP%]{display:flex}#unit-search-container[_ngcontent-%COMP%] > [_ngcontent-%COMP%]:not(:first-child){margin-left:.5rem}"];
exports.styles = styles;
